import request from '../setup/request';
const info = {
  /**
   * 根据景区获取门票配置信息
   *
   */
  getTicketInfoEx(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.info.getTicketInfoEx',
    });
  },
  /**
   * 退票
   *
   */
  getTicketsRefund(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.user.refund',
    });
  },
  /**
   * 根据景区和日期获取当天各时段余票数量
   *
   */
  getRestTickets(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.info.getRestTickets',
    });
  },
  /**
   * 获取首页广告
   *
   */
  getAd(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.info.getAd',
    });
  },
  /**
   * 获取门票购买提示
   *
   */
  getBookingTip(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.info.getBookingTip',
    });
  },
  /**
   * 获取景区列表
   *
   */
  getScenicArea(params) {
    return request.post('', {
      ...params,
      method: 'ih.cticket.info.getScenicArea',
    });
  },
};
export default info;
